import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import {
  Create,
  Delete,
  FileCopy,
  FileDownload,
  FolderOutlined,
  OpenInNew,
  RepartitionOutlined,
  Share,
} from "@mui/icons-material";
import {
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";

import { ThumbDown } from "@mui/icons-material";
import UnfoldMoreOutlinedIcon from "@mui/icons-material/UnfoldMoreOutlined";
import { useLocation } from "react-router-dom";
import { useUserProfile } from "../context/UserProfileContext.js";
import { useUser } from "../hooks/Authorize";
import { useTheme } from "../style/theme";
import FIDetailActivity from "./Dialogs/FIDetailActivity.jsx";
import MoveDialog from "./Dialogs/MoveDialog.jsx";
import RenameDialog from "./Dialogs/RenameDialog.jsx";
import SharingDialog from "./Dialogs/SharingDialog.jsx";
import StorageFullPopupDialog from "./Dialogs/StorageFullPopupDialog.jsx";
import ProgressBar from "./ProgressBar";
import FolderInfoMenu from "./SubMenus/FolderInfoMenu.jsx";
import OpenWithSubMenu from "./SubMenus/OpenWithSubMenu";
import OrganizeMenu from "./SubMenus/OrganizeSubMenu";
import { fileTypeMapping } from "./utils";

export default function ItemMorevertMenu({
  anchorEl,
  setAnchorEl,
  currentMenuClickedItem,
  setClikkleItems,
  item,
  items,
  handleDoubleClickFilePreview,
  anchorElSubMenu,
  setAnchorElSubMenu,
  anchorElOrganizeSubMenu,
  setAnchorElOrganizeSubMenu,
  anchorElFolderInfoSubMenu,
  setAnchorElFolderInfoSubMenu,
  submenuOpen,
  setSubmenuOpen,
  openSharingDialogModal,
  setOpenSharingDialogModal,
  openMoveDialogModal,
  setOpenMoveDialogModal,
}) {
  const [openFIDetailActivity, setOpenFIDetailActivity] = useState(false);
  const [openAddToShortcutDialogModal, setOpenAddToShortcutDialogModal] =
    useState(false);
  const [submenuLeftOffset, setSubmenuLeftOffset] = React.useState(0);
  const [openRenameDialog, setOpenRenameDialog] = useState(false);
  const [newName, setNewName] = useState("");
  const isMenuOpen = Boolean(anchorEl);
  const [isFolderInfoActivityTab, setIsFolderInfoActivityTab] = useState(false);
  const [processingMessage, setProcessingMessage] = useState("");
  const [showProcessingSnackbar, setShowProcessingSnackbar] = useState(false);
  const location = useLocation();
  const { mode } = useTheme();
  const platformUser = JSON.parse(localStorage.getItem("user"));

  var isTrashScreen = location.pathname === "/trash";
  const hasEditorAccess =
    platformUser._id === currentMenuClickedItem.ownerId ||
    currentMenuClickedItem.sharedWith?.some(
      (user) =>
        user.userId === platformUser._id && user.permissionType === "Editor"
    );

  const { fsUserProfile, setFsUserProfile } = useUserProfile();
  const [userTotalSpacePlan, setUserTotalSpacePlan] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);
  const [isSpaceFull100ModalOpen, setIsSpaceFull100ModalOpen] = useState(false);

  const getFsUserProfile = useCallback(async () => {
    try {
      setIsLoadingProfile(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/user/${platformUser._id}`
      );
      setFsUserProfile(response.data);
      console.log("setFsUserProfile = ", response.data);
    } catch (error) {
      console.error("Profile Fetch Error:", error);
    } finally {
      setIsLoadingProfile(false);
    }
  }, [platformUser._id, setFsUserProfile]);

  const checkSubscriptionDetails = useCallback(async () => {
    try {
      setIsLoadingSubscription(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/subscription/${platformUser._id}`
      );

      const data = response.data;
      setUserTotalSpacePlan(data?.permissions);
    } catch (error) {
      console.log("API Error:", error?.response?.data);
    } finally {
      setIsLoadingSubscription(false);
    }
  }, [platformUser._id]);

  useEffect(() => {
    getFsUserProfile();
    checkSubscriptionDetails();
  }, [getFsUserProfile, checkSubscriptionDetails]);

  // Storage calculation logic
  const BYTES_IN_GB = 1073741824;
  const BYTES_IN_MB = 1048576;

  const noOfAllowed = userTotalSpacePlan?.noOfAllowed ?? 5;
  const format = userTotalSpacePlan?.format ?? "GB";
  const isUnlimited = userTotalSpacePlan?.isUnlimited ?? false;

  let TOTAL_SPACE_GB = 0;
  let percentageUsed = 0;
  let isSpaceFull100 = false;

  if (!isUnlimited) {
    if (format === "TB") {
      TOTAL_SPACE_GB = noOfAllowed * 1024;
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedGB = usedBytes / BYTES_IN_GB;
      percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
    } else if (format === "GB") {
      TOTAL_SPACE_GB = noOfAllowed;
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedGB = usedBytes / BYTES_IN_GB;
      percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
    } else if (format === "MB") {
      TOTAL_SPACE_GB = noOfAllowed;
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedMB = usedBytes / BYTES_IN_MB;
      percentageUsed = (usedMB / TOTAL_SPACE_GB) * 100;
    }

    isSpaceFull100 = percentageUsed >= 90;
  }

  useEffect(() => {
    if (!anchorEl) {
      setAnchorElSubMenu(null);
    }
    setAnchorElFolderInfoSubMenu(null);
    setAnchorElOrganizeSubMenu(null);
  }, [anchorEl, setAnchorElSubMenu, setAnchorElFolderInfoSubMenu, setAnchorElOrganizeSubMenu]);

  const handleSubMenuOpen = (event) => {
    setAnchorElSubMenu(event.currentTarget);
    const rect = event.currentTarget.getBoundingClientRect();
    setSubmenuLeftOffset(rect.width - 20);
  };

  const handleSubMenuClose = () => {
    setAnchorElSubMenu(null);
  };

  const handleOrganizeSubMenuOpen = (event) => {
    setAnchorElOrganizeSubMenu(event.currentTarget);
    const rect = event.currentTarget.getBoundingClientRect();
    setSubmenuLeftOffset(rect.width - 20);
    setSubmenuOpen(true);
  };

  const handleFolderInfoSubMenuOpen = (event) => {
    setAnchorElFolderInfoSubMenu(event.currentTarget);
    const rect = event.currentTarget.getBoundingClientRect();
    setSubmenuLeftOffset(rect.width - 20);
    setSubmenuOpen(true);
  };

  const handleOpenActivityTab = (event) => {
    setOpenFIDetailActivity(true);
    handleSubMenuClose();
    setAnchorEl(null);
    setIsFolderInfoActivityTab(true);
  };

  const handleOpenMoveDialogModal = () => {
    setOpenMoveDialogModal(true);
    handleSubMenuClose();
    setAnchorEl(null);
  };

  const handleCloseMoveDialogModal = () => {
    setOpenMoveDialogModal(false);
  };

  const handleOpenFIDetailActivityDialogModal = () => {
    setOpenFIDetailActivity(true);
    handleSubMenuClose();
    setAnchorEl(null);
    setIsFolderInfoActivityTab(false);
  };

  const handleCloseFIDetailActivityDialogModal = () => {
    setOpenFIDetailActivity(false);
  };

  const handleOpenAddToShortcutDialogModal = () => {
    setOpenAddToShortcutDialogModal(true);
    handleSubMenuClose();
    setAnchorEl(null);
  };

  const handleCloseAddToShortcutDialogModal = () => {
    setOpenAddToShortcutDialogModal(false);
  };

  const handleOrganizeSubMenuClose = () => {
    setAnchorElOrganizeSubMenu(null);
  };

  const handleFolderInfoSubMenuClose = () => {
    setAnchorElFolderInfoSubMenu(null);
    setSubmenuOpen(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuOpen(null);
  };

  const handleOpenSharingModal = (item) => {
    setOpenSharingDialogModal(true);
    setAnchorEl(null);
    console.log("Sharing modal: ", currentMenuClickedItem);
  };

  const handleCloseModal = () => {
    setOpenSharingDialogModal(false);
  };

  const handleRenameSubmit = async (item) => {
    try {
      setProcessingMessage("Renaming ...");
      setShowProcessingSnackbar(true);

      const response = await axios.put(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${currentMenuClickedItem._id}`,
        {
          id: currentMenuClickedItem._id,
          updates: { name: newName },
          userId: platformUser._id,
        }
      );
      console.log("API Response:", response.data);

      setClikkleItems((prevItems) =>
        prevItems.map((prevItem) =>
          prevItem._id === currentMenuClickedItem._id
            ? { ...prevItem, name: newName }
            : prevItem
        )
      );
    } catch (error) {
      console.error("Error calling API:", error);
    }
    setShowProcessingSnackbar(false);
    setOpenRenameDialog(false);
  };

  const handleRenameItemClick = async (item) => {
    setAnchorEl(null);
    setOpenRenameDialog(true);
    setNewName(currentMenuClickedItem.name);
  };

  const handleDownloadClick = async (item) => {
    try {
      console.log(isSpaceFull100);
      if (isSpaceFull100 || isLoadingProfile || isLoadingSubscription) {
        setIsSpaceFull100ModalOpen(true);
        return;
      }
      setAnchorEl(null);
      setShowProcessingSnackbar(true);
      setProcessingMessage("Downloading...");
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/download/${item._id}?userId=${platformUser._id}`,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const filename = item.type === "folder" ? `${item.name}.zip` : item.name;
      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setShowProcessingSnackbar(false);
    } catch (error) {
      console.error("Download error:", error);
      setShowProcessingSnackbar(false);
    }
  };

  const handleCopyItemClick = async (item) => {
    try {
      setAnchorEl(null);
      setProcessingMessage("Copying...");
      setShowProcessingSnackbar(true);

      const response = await axios.post(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/copy/`,
        {
          resourceId: item._id,
          userId: platformUser._id,
        }
      );

      console.log("API Response:", response.data);

      if (platformUser._id === item.ownerId) {
        setClikkleItems((prevItems) => [...prevItems, response.data]);
      }
      setShowProcessingSnackbar(false);
    } catch (error) {
      setShowProcessingSnackbar(false);
      console.error("Error calling API:", error);
    }
  };

  const handleDeleteResource = async (item, restore = false) => {
    setShowProcessingSnackbar(true);
    setProcessingMessage(restore ? "Restoring..." : "Deleting...");
    try {
      var payload = {
        id: item._id,
        isTrashed: !item.isTrashed,
        userId: platformUser._id,
      };
      if (restore) {
        payload.restore = restore;
      }
      if (item.isTrashed && restore === false) {
        payload.permanentDelete = true;
      }

      setAnchorEl(null);
      const response = await axios.put(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${item._id}`,
        payload
      );
      console.log("API Response:", response.data);
      setClikkleItems((prevItems) =>
        prevItems.filter((currentItem) => {
          return currentItem._id !== item._id;
        })
      );

      if (payload.permanentDelete && response.data.usedSpace) {
        setFsUserProfile((prevProfile) => ({
          ...prevProfile,
          usedSpace: response.data.usedSpace,
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
    setShowProcessingSnackbar(false);
  };

  return (
    <>
      <ProgressBar
        showProcessingSnackbar={showProcessingSnackbar}
        processingMessage={processingMessage}
      />

      <SharingDialog
        handleCloseModal={handleCloseModal}
        openModal={openSharingDialogModal}
        item={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        setShowProcessingSnackbar={setShowProcessingSnackbar}
        setProcessingMessage={setProcessingMessage}
      />

      <MoveDialog
        handleCloseModal={handleCloseMoveDialogModal}
        openModal={openMoveDialogModal}
        item={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        setShowProcessingSnackbar={setShowProcessingSnackbar}
        setProcessingMessage={setProcessingMessage}
      />

      <MoveDialog
        handleCloseModal={handleCloseAddToShortcutDialogModal}
        openModal={openAddToShortcutDialogModal}
        item={currentMenuClickedItem}
        isAddToShortCutDialog={true}
        setClikkleItems={setClikkleItems}
        setShowProcessingSnackbar={setShowProcessingSnackbar}
        setProcessingMessage={setProcessingMessage}
      />

      <RenameDialog
        openRenameDialog={openRenameDialog}
        setOpenRenameDialog={setOpenRenameDialog}
        currentMenuClickedItem={currentMenuClickedItem}
        newName={newName}
        setNewName={setNewName}
        items={items}
        handleRenameSubmit={handleRenameSubmit}
      />

      <FIDetailActivity
        open={openFIDetailActivity}
        setOpenFIDetailActivity={setOpenFIDetailActivity}
        setOpenSharingDialogModal={setOpenSharingDialogModal}
        onClose={handleCloseFIDetailActivityDialogModal}
        currentMenuClickedItem={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        isFolderInfoActivityTab={isFolderInfoActivityTab}
      />

      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: "250px",
            borderRadius: "12px",
            padding: "4px 0",
            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            background:
              mode === "dark" ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",
          },
        }}
      >
        {!isTrashScreen && (
          <>
            {currentMenuClickedItem.type === "file" &&
              fileTypeMapping.Image.includes(
                currentMenuClickedItem.name?.split(".").pop().toLowerCase()
              ) && (
                <>
                  <MenuItem
                    onClick={handleSubMenuOpen}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 16px",
                      fontSize: "14px",
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: "24px" }}>
                      <OpenInNew fontSize="small" />
                    </ListItemIcon>
                    Open With
                  </MenuItem>
                  <Divider
                    sx={{
                      borderColor:
                        mode === "dark"
                          ? "rgba(255,255,255,0.15)"
                          : "rgba(165, 165, 165, 0.59)",
                    }}
                  />
                </>
              )}

            <OpenWithSubMenu
              anchorElSubMenu={anchorElSubMenu}
              handleSubMenuClose={handleSubMenuClose}
              currentMenuClickedItem={currentMenuClickedItem}
              setAnchorEl={setAnchorEl}
              handleDoubleClickFilePreview={handleDoubleClickFilePreview}
            />

            <MenuItem
              onClick={() => handleDownloadClick(item)}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <FileDownload fontSize="small" />
              </ListItemIcon>
              Download
            </MenuItem>

            {hasEditorAccess && !item.isShortcut && (
              <MenuItem
                onClick={() => handleRenameItemClick(item)}
                sx={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  padding: "12px 16px",
                  fontSize: "14px",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                }}
              >
                <ListItemIcon sx={{ minWidth: "24px" }}>
                  <Create fontSize="small" />
                </ListItemIcon>
                Rename
              </MenuItem>
            )}

            <MenuItem
              onClick={() => handleCopyItemClick(item)}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <FileCopy fontSize="small" />
              </ListItemIcon>
              Make a Copy
            </MenuItem>

            {hasEditorAccess && (
              <Divider
                sx={{
                  borderColor:
                    mode === "dark"
                      ? "rgba(255,255,255,0.15)"
                      : "rgba(165, 165, 165, 0.59)",
                }}
              />
            )}
          </>
        )}

        {hasEditorAccess && (
          <MenuItem
            onClick={() => handleDeleteResource(item)}
            sx={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              padding: "12px 16px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <Delete fontSize="small" />
            </ListItemIcon>
            {isTrashScreen ? "Delete Permanently" : "Move to Trash"}
          </MenuItem>
        )}

        {isTrashScreen && (
          <MenuItem
            onClick={() => handleDeleteResource(item, true)}
            sx={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              padding: "12px 16px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <RepartitionOutlined fontSize="small" />
            </ListItemIcon>
            Restore
          </MenuItem>
        )}

        {!isTrashScreen && hasEditorAccess && (
          <>
            <MenuItem
              onClick={() => handleDeleteResource(item)}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <ThumbDown fontSize="small" />
              </ListItemIcon>
              Not Helpful
            </MenuItem>

            <Divider
              sx={{
                borderColor:
                  mode === "dark"
                    ? "rgba(255,255,255,0.15)"
                    : "rgba(165, 165, 165, 0.59)",
              }}
            />

            <MenuItem
              onClick={() => handleOpenSharingModal(item)}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <Share fontSize="small" />
              </ListItemIcon>
              Share
            </MenuItem>

            <MenuItem
              onClick={handleOrganizeSubMenuOpen}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <UnfoldMoreOutlinedIcon fontSize="small" />
              </ListItemIcon>
              Organize
            </MenuItem>

            {submenuOpen && (
              <OrganizeMenu
                anchorElSubMenu={anchorElOrganizeSubMenu}
                setAnchorEl={setAnchorEl}
                handleOpenMoveDialogModal={handleOpenMoveDialogModal}
                handleOpenAddToShortcutDialogModal={
                  handleOpenAddToShortcutDialogModal
                }
                handleSubMenuClose={handleOrganizeSubMenuClose}
                setClikkleItems={setClikkleItems}
                currentMenuClickedItem={currentMenuClickedItem}
                setShowProcessingSnackbar={setShowProcessingSnackbar}
                setProcessingMessage={setProcessingMessage}
              />
            )}

            <MenuItem
              onClick={handleFolderInfoSubMenuOpen}
              sx={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "12px 16px",
                fontSize: "14px",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: "24px" }}>
                <FolderOutlined fontSize="small" />
              </ListItemIcon>
              {currentMenuClickedItem.type === "folder" ? "Folder " : "File "}
              Information
            </MenuItem>

            {submenuOpen && (
              <FolderInfoMenu
                anchorElSubMenu={anchorElFolderInfoSubMenu}
                handleOpenFIDetailActivityDialogModal={
                  handleOpenFIDetailActivityDialogModal
                }
                handleSubMenuClose={handleFolderInfoSubMenuClose}
                currentMenuClickedItem={currentMenuClickedItem}
                handleOpenActivityTab={handleOpenActivityTab}
                setAnchorEl={setAnchorEl}
              />
            )}
          </>
        )}
      </Menu>

      {/* Only show popup if storage is actually 100% full */}
      {isSpaceFull100 && (
        <StorageFullPopupDialog
          isSpaceFull100ModalOpen={isSpaceFull100ModalOpen}
          isSpaceFull100={isSpaceFull100}
          is100Full={isSpaceFull100}
          setIsSpaceFull100ModalOpen={setIsSpaceFull100ModalOpen}
          isUnlimited={isUnlimited}
          dialogLoading={isLoadingProfile || isLoadingSubscription}
          noOfAllowed={noOfAllowed}
          format={format}
        />
      )}
    </>
  );
}